<template>
  <div>
    <slot name="title">
      <label v-if="label" :for="prop" class="mb-2 inline-block" v-tooltip :title="tooltip">
        {{ label }}
        <span v-if="required" class="text-red-600">*</span>
        <UiIcon v-if="tooltip" icon="info-circle" class="!align-bottom" size="16" strokeWidth="1.5" />
      </label>
    </slot>
    <slot />
    <transition name="slide">
      <div v-if="validation[prop]?.$messages[0]" class="mt-1 text-xs text-[#FF4980]">{{ validation[prop]?.$messages[0] }}</div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { inject, provide } from 'vue'
import UiIcon from '@/components/ui/icon.vue'

const { label = '', prop = '', required = false, tooltip = '' } = defineProps<{
  label?: string
  prop?: string
  required?: boolean
  tooltip?: string
}>()

const validation = inject('validation', {})
provide('fc-prop', prop)
</script>
